import { JSONPatchDocument } from "@ofqual/portal-core/core/types";
import { modelToJsonPatchDocument } from "@ofqual/portal-core/core/utils/modelHelpers";
import { Team } from "../../services/domain/Team";
import { User } from "../../services/domain/User";

export type UserViewModel = User & {
  teamIds: string[];
};

export const defaultValues: Partial<UserViewModel> = {
  userRoles: [],
  title: "",
  teamIds: [],
};

export const toViewModel = (user: User): UserViewModel => {
  return {
    ...user,
    teamIds: user.userTeams.map((item) => item.id),
  };
};

export const fromViewModel = (
  viewModel: UserViewModel,
  dirtyFields: (keyof UserViewModel)[]
): JSONPatchDocument => {
  // if the view has changed teamdIds, we need out patch to contain a line for
  // "userTeams" and to have teamIds removed.
  if (dirtyFields.includes("teamIds")) {
    viewModel.userTeams = viewModel.teamIds.map((id) => ({ id } as Team));
    dirtyFields = dirtyFields.filter((item) => item !== "teamIds");
    dirtyFields = [...dirtyFields, "userTeams"];
  }

  return modelToJsonPatchDocument(viewModel, dirtyFields);
};
